import { render, staticRenderFns } from "./top_company_info.vue?vue&type=template&id=06dc7f4b"
import script from "./top_company_info.vue?vue&type=script&lang=js"
export * from "./top_company_info.vue?vue&type=script&lang=js"
import style0 from "./top_company_info.vue?vue&type=style&index=0&id=06dc7f4b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports